export default "__VITE_ASSET__7tIv_HJR__"